export default {

    resetReviews: ({state, commit}) => {
        commit(
            "updateReviewsDataWithResponse", 
            window.reviews
            )

        commit("resetReviewsArray")

        commit(
            "addReviewsFromResponse",
            window.reviews.reviews
        )
    },

    

    loadReviews: async ({state, commit, getters}, pageNo) => {
        const responseReviewData = state.responseReviewData
        const ratingsToShow = state.ratingsToShow
        const locale = getters.locale
        const start = pageNo
        const liheId = state.liheId

        const isHaveResponse = responseReviewData && Object.keys(responseReviewData).length > 0
        if (isHaveResponse && (responseReviewData.pageCurrentNum === responseReviewData.pageCount)) {
            return
        }
        
        commit("setLoading", true)

        const requestData = {locale, "size": 10, start, liheId}
    
        if (ratingsToShow) {
            requestData["averageRatingMin"] = ratingsToShow
            requestData["averageRatingMax"] = ratingsToShow + 1
        }
        const res = await window.feedbackService.getRateByLihe(requestData)
    
        if (pageNo === 0) commit("resetReviewsArray")
        commit("updateReviewsDataWithResponse", res)
        commit("addReviewsFromResponse", res.reviews)

        commit("setLoading", false)
    },
}